const AppMessages = {
	PublicKeyLabel: "Please choose your public key file",
	PrivateKeyLabel: "Please choose your private key file",
	PrivateNetError:
		"We couldn’t establish a connection to a PrivateNet at this address, please try again",
	PrivateKeyFormat: "Invalid Private Key Format",

	PrivateKeyDownloaded:
		"Private key has been successfully saved to your downloads folder",

	SidechainGrantAccessText: "Grant access to Sidechain?",
	SidechainAddUserDialogPasteText:
		"Paste invitee’s public keys and assign roles to invite them to this weave.",
	SidechainAddUserDialogNoteText:
		"**Note that all roles assigned will apply across all data collections on the weave. For more granular data role permissioning, create new custom roles**",

	ScopesMenuText: "Data",
	ScopesPageTitle: "Data Collections",
	ScopesNoAccessText: "You don’t have access to any data collections.",
	ScopesAddUserDialogTitle: "Add Users to Data Collection",
	ScopesAddUserDialogClickText: "Click here to invite users to the weave",
	ScopesAddUserDialogPasteText:
		"Paste invitee’s public keys and assign roles to add them to this data collection. Users must already be part of this weave to be invited.",
	ScopesAddUserDialogNoteText:
		"**Note that the data role assigned may have access to other data collection hosted on the weave**",
	ScopesAddUserCancelButtonText: "Cancel",
	ScopesAddUserOkButtonText: "Add to Data Collection",
	ScopeAppliesText: "applies across all data collections in weave",
	ScopeChooseRightsText:
		"Choose the rights to assign to the data collection below",
	ScopeGrantAccessText: "Grant access to data collection?",
	ScopeOracleDataSourceText:
		"Choose which data collection and tables to read data from",
	ScopeUserAddedText: "Users added to data collection successfully!",
	TablePrivateText: ` is available for local access only by node ‘ACME SF.Oncology’.\n It is available to you for confidential computing.`,
	PublishTableNameNote:
		"This title does not affect the original table name; it only appears in the data marketplace",
	PublishTableDescriptionPlaceholder:
		"ex. An anonymized dataset of how people spend all their time, categorized by demographics such as age, gender, employment, and others.",
	PublishTableDescriptionNote:
		"Enter a brief description of contents to be published to the marketplace. Markdown accepted.",
	PublishTableMarketplaceNote:
		"Visit or share this permalink to this table in the data marketplace",
	PublishTableFooterNote:
		"Datasets are live, so any changes you make to the dataset will be updated in realtime for consumers.",
	PublishTableRowsChangeNote: "Update this setting in ",
	PublishTableFeeAlert:
		"Adding, editing, or removing fees will affect fee structure throughout the data collection",
};

export default AppMessages;
